import styles from "../PaceLandingLayout/PaceLandingLayout.styles";

// Material UI components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Others
import { FormattedMessage } from "react-intl";

const CommonContent = (): JSX.Element => {
    const classes = styles.paceLandingLayoutStyles();

    return (
        <>
            <Box className={classes.aboutTextBox} fontSize={14}>
                <Typography variant="body2" fontWeight={700}>
                    <FormattedMessage id="pace.about.subtitle.1" />
                </Typography>
                <Typography variant="body2">
                    <FormattedMessage id="pace.about.list.1" />
                </Typography>
            </Box>
            <Box className={classes.aboutTextBox}>
                <Typography variant="body2" fontWeight={700}>
                    <FormattedMessage id="pace.about.subtitle.2" />
                </Typography>
                <Typography variant="body2">
                    <FormattedMessage id="pace.about.list.2" />
                </Typography>
            </Box>
            <Box className={classes.aboutTextBox}>
                <Typography variant="body2" fontWeight={700}>
                    <FormattedMessage id="pace.about.subtitle.3" />
                </Typography>
                <Typography variant="body2">
                    <FormattedMessage id="pace.about.list.3" />
                </Typography>
            </Box>
        </>
    );
};

export default CommonContent;
